import { takeEvery, put, call } from "redux-saga/effects"
import { NotifHelper } from "../../components/Common/NotifHelper"
import * as msg from "../../constants/responseMessage"

// Calender Redux States
import {
    ADD_ACCOUNT_TRANSACTION_CLIENT,
    DELETE_ACCOUNT_TRANSACTION_CLIENT,
    APPROVE_ACCOUNT_TRANSACTION_CLIENT,
    ADD_ACCOUNT_TRANSACTION_CLIENT_BANK,
    ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT
} from "./actionTypes"
import {
    addAccountTransactionClientSuccess,
    addAccountTransactionClientFail,
    deleteAccountTransactionClientSuccess,
    deleteAccountTransactionClientFail,
    approveAccountTransactionClientSuccess,
    approveAccountTransactionClientFail,
    addAccountTransactionClientBankSuccess,
    addAccountTransactionClientBankFail,
    addAccountTransactionClientByExcelSuccess,
    addAccountTransactionClientByExcelFail
} from "./actions"

//Include Both Helper File with needed methods
import {
    addAccountTransactionClient,
    deleteAccountTransactionClient,
    approveAccountTransactionClient,
    addAccountTransactionClientBank,
    addAccountTransactionClientByExcel
} from "../../helpers/backend_helper"

function* onAddAccountTransactionClient({ payload: { data, history } }) {
    try {
        const response = yield call(addAccountTransactionClient, data)
        if (response.status) {
            NotifHelper.success(msg.ACCOUNT_TRANSACTION_CLIENT_ADD_SUCCESS)
            yield put(addAccountTransactionClientSuccess())
            history.push("/client-transaction/transaction")
        }
        else {
            NotifHelper.error(response.message)
            yield put(addAccountTransactionClientFail(response.message))
        }
    } catch (error) {
        NotifHelper.error(error)
        yield put(addAccountTransactionClientFail(error))
    }
}

function* onDeleteAccountTransactionClient({ payload: { data, callback } }) {
    try {
        const response = yield call(deleteAccountTransactionClient, data)
        if (response.status) {
            NotifHelper.success(msg.ACCOUNT_TRANSACTION_CLIENT_DELETE_SUCCESS)
            yield put(deleteAccountTransactionClientSuccess())
            callback()
        }
        else {
            NotifHelper.error(response.message)
            yield put(deleteAccountTransactionClientFail(response.message))
        }
    } catch (error) {
        NotifHelper.error(error)
        yield put(deleteAccountTransactionClientFail(error))
    }
}

function* onApproveAccountTransactionClient({ payload: { data, callback } }) {
    try {
        const response = yield call(approveAccountTransactionClient, data)
        if (response.status) {
            NotifHelper.success(data.approved ? msg.ACCOUNT_TRANSACTION_CLIENT_APPROVE_SUCCESS : msg.ACCOUNT_TRANSACTION_CLIENT_REJECTED_SUCCESS)
            yield put(approveAccountTransactionClientSuccess())
            callback()
        }
        else {
            NotifHelper.error(response.message)
            yield put(approveAccountTransactionClientFail(response.message))
        }
    } catch (error) {
        NotifHelper.error(error)
        yield put(approveAccountTransactionClientFail(error))
    }
}

function* onAddAccountTransactionClientBank({ payload: { companyId, accountNumberId, tipeBank, uploadFile, history } }) {
    try {
        const response = yield call(addAccountTransactionClientBank, uploadFile, {
            companyId: companyId,
            accountNumberId: accountNumberId,
            tipeAccountNumber: tipeBank
        })
        if (response.status) {
            NotifHelper.success(msg.ACCOUNT_TRANSACTION_CLIENT_BANK_ADD_SUCCESS)
            yield put(addAccountTransactionClientBankSuccess())
            history.push("/client-transaction/transaction")
        }
        else {
            NotifHelper.error(response.message)
            yield put(addAccountTransactionClientBankFail(response.message))
        }
    } catch (error) {
        NotifHelper.error(error)
        yield put(addAccountTransactionClientBankFail(error))
    }
}

function* onAddAccountTransactionClientByExcel({ payload: { uploadFile, companyId, history } }) {
    try {
        const response = yield call(addAccountTransactionClientByExcel, uploadFile, {
            companyId: companyId
        })
        if (response.status) {
            NotifHelper.success(msg.ACCOUNT_TRANSACTION_ADD_SUCCESS)
            yield put(addAccountTransactionClientByExcelSuccess())
            history.push("/client-transaction/transaction")
        }
        else {
            NotifHelper.error(response.message)
            yield put(addAccountTransactionClientByExcelFail(response.message))
        }
    } catch (error) {
        NotifHelper.error(error)
        yield put(addAccountTransactionClientByExcelFail(error))
    }
}

function* accountTransactionClientSaga() {
    yield takeEvery(ADD_ACCOUNT_TRANSACTION_CLIENT, onAddAccountTransactionClient)
    yield takeEvery(DELETE_ACCOUNT_TRANSACTION_CLIENT, onDeleteAccountTransactionClient)
    yield takeEvery(APPROVE_ACCOUNT_TRANSACTION_CLIENT, onApproveAccountTransactionClient)
    yield takeEvery(ADD_ACCOUNT_TRANSACTION_CLIENT_BANK, onAddAccountTransactionClientBank)
    yield takeEvery(ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT, onAddAccountTransactionClientByExcel)
}

export default accountTransactionClientSaga